export default {
  api: {
    list: {
      method: "get",
      url: "/user/notice/list"
    },
    readAll: {
      method: "post",
      url: "/user/notice/readAll"
    },
    getMessageCount: {
      method: "get",
      url: "/user/notice/getMessageCount"
    },
    readMessage: {
      method: "put",
      url: "/user/notice/readMessage/{messageId}"
    },
    getInfo: {
      method: "get",
      url: "/admin/notice/advice/info/{noticeId}"
    }
  }
};
